import { useState, useEffect } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useOutletContext } from 'react-router-dom';

const TabSettings = () => {
    const { details, isLoading } = useOutletContext();

    const steps = [
        { id: 'details', icon:'bx bx-user', title: 'Account Details', link:"/notarialbook/settings/userdetails" },
        { id: 'notary', icon:'bx bx-briefcase-alt-2', title: 'Notarial Details', link:"/notarialbook/settings/notarydetails" },
        { id: 'security', icon:'bx bx-cog',title: 'Security', link: "/notarialbook/settings/security" },
    ];

    const [activeStep, setActiveStep] = useState('');
    const pagelocation = useLocation();
  

    useEffect(() => {
      if (pagelocation.pathname.startsWith('/notarialbook/settings/userdetails')) {
        setActiveStep('details');
      }
      else if (pagelocation.pathname.startsWith('/notarialbook/settings/notarydetails')) {
        setActiveStep('notary');
      }
      else if (pagelocation.pathname.startsWith('/notarialbook/settings/security')) {
        setActiveStep('security');
      } else {
        setActiveStep('');
      }
      console.log(pagelocation.pathname);
    }, [pagelocation.pathname]);


    return (    
        <div className="col-md-12">
            <div className="row">
                <div className="col-md-2">
                    <div className="d-flex justify-content-between flex-column mb-2 mb-md-0">
                        <ul className="nav nav-align-left nav-pills flex-column">
                            {steps.map((step) => (
                                <li key={step.id } className="nav-item">
                                     <Link to={step.link} className={` nav-link w-150px ${activeStep === step.id ? 'active' : ''}`}  onClick={() => setActiveStep(step.id)} >
                                        <i className={`${step.icon} me-1`} />
                                        <div>{step.title}</div>
                                    </Link>

                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Step Content */}
                <div className="col-md-10">
                    <Outlet context={{details,isLoading}}/>
                </div>
            </div>

        </div>
    );
}
 
export default TabSettings;